import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { InternalRoute } from "../../interfaces/InternalRoute.Interface";
import "./InternalRouter.Styles.scss";

interface Props {
  internalRoutes: InternalRoute[];
}

export default function InternalRouter(props: Props) {
  const history = useHistory();
  const location = useLocation();

  const renderInternalRoutes = () => {
    return props.internalRoutes.map((ele, index) => {
      return (
        <div
          key={index}
          onClick={() => history.push(ele.route)}
          className={`intenal-route-element ${
            location.pathname === ele.route
              ? "intenal-route-element-active"
              : ""
          }`}
        >
          <FontAwesomeIcon icon={ele.icon} />
        </div>
      );
    });
  };

  const renderRoute = () => {
    for (const i of props.internalRoutes) {
      if (location.pathname === i.route) {
        return i.component ? <i.component /> : <div></div>;
      }
    }
  };

  return (
    <div className="internal-router-outercontainer">
      <div className="internal-router-routes">{renderInternalRoutes()}</div>
      <div className="internal-router-container">{renderRoute()}</div>
    </div>
  );
}
